export enum ButtonActionTypes {
    LeavePage = "leavePage",
    AddCustomer = "addCustomer",
    UpdateCustomer = "updateCustomer",
    DeleteCustomer = "deleteCustomer"
}

export {};